import { useNavigate } from "react-router-dom";
import Footer from "../components/Footer";

export default function NotFoundPage() {
  const navigate = useNavigate();

  return (
    <div style={{ minHeight: "100vh", display: "flex", flexDirection: "column", backgroundColor: "#F7F4EF" }}>
      <div style={{ flex: 1, display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", padding: "80px 24px", textAlign: "center" }}>

        {/* Ghost 404 number */}
        <p style={{
          fontFamily: "'Cinzel', serif",
          fontWeight: 700,
          fontSize: "clamp(90px, 18vw, 180px)",
          color: "rgba(1,46,114,0.06)",
          lineHeight: 1,
          letterSpacing: "0.04em",
          marginBottom: "-20px",
          userSelect: "none",
        }}>
          404
        </p>

        {/* Shield icon */}
        <div style={{
          width: "68px", height: "68px",
          borderRadius: "20px",
          backgroundColor: "rgba(1,46,114,0.07)",
          display: "flex", alignItems: "center", justifyContent: "center",
          marginBottom: "24px",
        }}>
          <svg width="30" height="30" viewBox="0 0 24 24" fill="none" stroke="rgba(1,46,114,0.45)" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
            <path d="M12 2L3 7v5c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V7l-9-5z" />
            <line x1="12" y1="8" x2="12" y2="13" />
            <line x1="12" y1="16" x2="12.01" y2="16" />
          </svg>
        </div>

        <h1 style={{
          fontFamily: "'Cinzel', serif",
          fontWeight: 700,
          fontSize: "clamp(22px, 4vw, 34px)",
          color: "#012E72",
          letterSpacing: "0.04em",
          marginBottom: "14px",
        }}>
          Page Not Found
        </h1>

        <p style={{
          fontFamily: "'Constantia', 'Georgia', serif",
          fontSize: "16px",
          color: "rgba(1,46,114,0.5)",
          maxWidth: "420px",
          lineHeight: 1.75,
          marginBottom: "40px",
        }}>
          The page you're looking for doesn't exist or may have been moved.
        </p>

        <div style={{ display: "flex", gap: "12px", flexWrap: "wrap", justifyContent: "center" }}>
          <button
            onClick={() => navigate("/")}
            style={{
              fontFamily: "'Cinzel', serif",
              fontSize: "9px",
              letterSpacing: "0.18em",
              textTransform: "uppercase",
              color: "#fff",
              background: "linear-gradient(135deg, #012E72, #002DB5)",
              border: "none",
              borderRadius: "999px",
              padding: "13px 32px",
              cursor: "pointer",
              boxShadow: "0 4px 20px rgba(0,45,181,0.28)",
              transition: "opacity 0.15s",
            }}
            onMouseEnter={e => { e.currentTarget.style.opacity = "0.88"; }}
            onMouseLeave={e => { e.currentTarget.style.opacity = "1"; }}
          >
            Return Home
          </button>
          <button
            onClick={() => navigate(-1)}
            style={{
              fontFamily: "'Cinzel', serif",
              fontSize: "9px",
              letterSpacing: "0.18em",
              textTransform: "uppercase",
              color: "#012E72",
              backgroundColor: "transparent",
              border: "1px solid rgba(1,46,114,0.22)",
              borderRadius: "999px",
              padding: "13px 32px",
              cursor: "pointer",
              transition: "all 0.15s",
            }}
            onMouseEnter={e => { e.currentTarget.style.backgroundColor = "rgba(1,46,114,0.06)"; }}
            onMouseLeave={e => { e.currentTarget.style.backgroundColor = "transparent"; }}
          >
            Go Back
          </button>
        </div>
      </div>
      <Footer />
    </div>
  );
}
